(function () {
  function stripBefore(root, markerText) {
    var candidates = root.querySelectorAll('h1, h2, h3, h4, p');
    var startNode = null;
    for (var i = 0; i < candidates.length; i++) {
      var text = candidates[i].textContent.replace(/\s+/g, ' ').trim();
      if (text.indexOf(markerText) === 0) {
        startNode = candidates[i];
        break;
      }
    }
    if (!startNode) return;

    var toRemove = [];
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT);
    var node;
    while ((node = walker.nextNode())) {
      if (node === startNode) break;
      if (!node.contains(startNode)) toRemove.push(node);
    }
    toRemove.forEach(function (n) {
      if (n.parentNode) n.parentNode.removeChild(n);
    });
  }

  function markServiceCopy(root) {
    var inService = false;
    root.querySelectorAll('h2, h3, h4, p').forEach(function (node) {
      var tag = node.tagName;
      if (tag === 'H2') {
        inService = false;
      } else if (tag === 'H3' || tag === 'H4') {
        inService = true;
      } else if (tag === 'P' && inService) {
        node.classList.add('iub-service-copy');
      }
    });
  }

  function init(container) {
    var endpoint = container.dataset.iubendaEndpoint;
    var skipUntil = container.dataset.iubendaSkipUntil;
    var fallbackUrl = container.dataset.iubendaFallbackUrl;

    fetch(endpoint)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (!data || !data.success || !data.content) return;
        var doc = new DOMParser().parseFromString(data.content, 'text/html');
        if (skipUntil) stripBefore(doc.body, skipUntil);
        markServiceCopy(doc.body);
        container.innerHTML = doc.body.innerHTML;
      })
      .catch(function () {
        container.innerHTML = '<p><a href="' + fallbackUrl + '">' + fallbackUrl + '</a></p>';
      });
  }

  document.querySelectorAll('.iubenda-api-content[data-iubenda-endpoint]').forEach(init);
})();
